/**
 * @file AlertBox.js
 * @description A React component that displays an alert box with a title and description.
 *
 * @param {string} backgroundColor - The background color of the alert box. Default is '#f0f4ff'.
 * @param {string} title - The main heading text to display in the alert.
 * @param {string} description - The descriptive text to display below the title.
 *
 * @returns {JSX.Element} The rendered AlertBox component.
 */
import React from 'react';
import PropTypes from 'prop-types';

const AlertBox = ({ backgroundColor = '#f0f4ff', title, description }) => {
    return (
        <div
            style={{
                backgroundColor,
                border: '1px dashed rgba(19, 102, 255, 0.30)',
                borderRadius: '8px',
                padding: '40px',
                textAlign: 'center',
                width: '576px',
                margin: '50px auto',
                marginTop: '20%',
            }}
        >
            <div
                style={{
                    borderRadius: '50%',
                    width: '60px',
                    height: '60px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: '0 auto 10px',
                    color: 'var(--iNGAGED-Accessory-Color1, var(--iNGAGED-Primary, #1366FF))',
                    fontSize: '60px',
                }}
            >
                <i className="bi bi-exclamation-circle"></i>
            </div>
            <p
                style={{
                    marginBottom: '10px',
                    fontSize: '20px',
                    fontWeight: '700',
                    color: '#333',
                }}
            >
                {title}
            </p>
            <p
                style={{
                    color: '#667085',
                    fontSize: '16px',
                    fontWeight: '500',
                }}
            >
                {description}
            </p>
        </div>
    );
};

AlertBox.propTypes = {
    backgroundColor: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
};

export default AlertBox;
